import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <Section background="paper" labelledBy="bonuses-heading" data-id="element-33" data-mp="plsky6ka14aa">
      <div className="text-center" data-id="element-34" data-mp="aua8ujujftw7">
        <p className="inline-flex items-center gap-2 rounded-full bg-sage-soft px-4 py-2 font-sans text-[11px] font-semibold uppercase leading-none tracking-[0.14em] text-sage" data-id="element-35" data-mp="at8uo6i86ra9">
          <GiftIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-36" data-mp="1t3pm30i84z9" />5 field bonuses
          included free
        </p>

        <h2 id="bonuses-heading" className="mx-auto mt-6 max-w-2xl font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[40px]" data-id="element-37" data-mp="3o1v5efaefsp5">
          Total bonus value: $95 → free with your Screen &amp; Adapt™
        </h2>
      </div>

      <ul className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-38" data-mp="1mb1if6y30974">
        {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col rounded-2xl border border-sage/15 bg-white p-6 shadow-card" data-id="element-39" data-mp="1r6z1hl0qbtnl">
            <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-brass" data-id="element-40" data-mp="3detvgxqj2wtm">
              Bonus {bonus.number}
            </p>
            <h3 className="mt-3 font-serif text-xl font-semibold leading-snug text-ink" data-id="element-41" data-mp="3n5es4fmn5r9w">
              {bonus.title}
            </h3>
            <p className="mt-3 font-sans text-[14px] font-semibold" data-id="element-42" data-mp="2zgddgan7tjw6">
              <span className="text-ink-muted line-through" data-id="element-43" data-mp="2uh0s5ubzskvp">{bonus.price}</span>
              <span className="ml-2 text-sage" data-id="element-44" data-mp="38g8tasrpu32j">→ Free</span>
            </p>
            <p className="mt-4 font-sans text-[15px] leading-[1.6] text-ink-soft" data-id="element-45" data-mp="38hjuckts0wpy">{bonus.body}</p>
          </li>)}
      </ul>
    </Section>;
}